import React, { FC, useState } from 'react';
import clsx from 'clsx';
import {
  Typography,
  Icon,
  Collapse,
  SwiperCarousel
} from '@npm-registry/eapteka-ui';
import { useSelector } from 'react-redux';
import { selectRecommendationProducts } from '../../../store/recommendationProducts';
import { RecommendationProductsStore } from '../../../store/recommendationProducts/types';
import { text } from '../../../text';
import { RecommendationProduct } from '../../elements/RecommendationProduct';
import { useObservable } from './hooks/useObservable';
import { RecommendationProductListProps } from './types';
import styles from './RecommendationProductList.scss';

export const RecommendationProductList: FC<
  RecommendationProductListProps
> = ({ className, productId }) => {
  const { childRef } = useObservable();
  const [isOpened, setOpen] = useState(false);
  const products = useSelector(
    (state: RecommendationProductsStore) =>
      selectRecommendationProducts(state, productId)
  );

  const rootClassNames = clsx(styles.root, className, {
    [styles.isOpened]: isOpened
  });
  const handleToggle = () => setOpen(!isOpened);

  if (!products.length) {
    return null;
  }

  return (
    <div className={rootClassNames} ref={childRef}>
      <Typography>
        <button
          className={styles.title}
          onClick={handleToggle}
          aria-label={text['recommendation.title']}
        >
          <span>{text['recommendation.title']}</span>
          <Icon
            className={styles.icon}
            name="chevronDown"
          />
        </button>
      </Typography>
      <Collapse
        className={styles.collapse}
        isEnter={isOpened}
      >
        <SwiperCarousel
          isOverflowVisible
          className={styles.scroll}
          slides={products.map((productId) => (
            <RecommendationProduct
              key={productId}
              id={productId}
            />
          ))}
          navigation={false}
          spaceBetween={0}
          slidesPerView="auto"
          breakpoints={{
            '320': {
              slidesPerView: 'auto',
              spaceBetween: 8
            },
            '992': {
              slidesPerView: 'auto',
              spaceBetween: 12
            },
            '1200': {
              slidesPerView: 'auto',
              spaceBetween: 12
            }
          }}
        />
      </Collapse>
    </div>
  );
};
